import React, { FC } from "react";
import { Styled } from "./Search.styled";

const Search: FC = () => {
  return <Styled.SearchLogo />;
};

export default Search;
